import React from 'react';
import { Form, Modal } from 'antd';
import { get, pickBy } from 'lodash';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import TextField from 'Parts/ui/components/fields/TextField';
import FakeField from 'Parts/ui/components/fields/FakeField';
import CancelAndSaveButtons from 'Parts/ui/components/CancelAndSaveButtons';
import FundkyButton from 'Parts/ui/components/FundkyButton';
import UploadCropField from 'Parts/ui/components/fields/UploadCropField';
import CheckboxField from 'Parts/ui/components/fields/CheckboxField';

import { customFieldValidator } from 'Parts/ui/validations/fieldValidations';

import TaxReceiptAdminConfigurationInformationForm_en from './locales/TaxReceiptAdminConfigurationInformationForm_en.json';
import TaxReceiptAdminConfigurationInformationForm_fr from './locales/TaxReceiptAdminConfigurationInformationForm_fr.json';

import './TaxReceiptAdminConfigurationInformationForm.less';

class TaxReceiptAdminConfigurationInformationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      serialNumber: '',
      displayActionModal: false,
      acceptModification: false,
      removeSignature: false,
      removeLogo: false
    };

    this.signatureUploadCropFieldRef = React.createRef();
    this.logoUploadCropFieldRef = React.createRef();

    i18next.addResourceBundle(
      'en',
      'TaxReceiptAdminConfigurationInformationForm',
      TaxReceiptAdminConfigurationInformationForm_en
    );
    i18next.addResourceBundle(
      'fr',
      'TaxReceiptAdminConfigurationInformationForm',
      TaxReceiptAdminConfigurationInformationForm_fr
    );
  }

  componentDidMount() {
    this.props.fetchTaxReceiptConfiguration().then(({ payload }) => {
      if (payload) {
        let prefix, sequence;
        prefix = payload.prefix || '';
        prefix = prefix + '_';
        sequence = this.formatSequence(payload.sequence);
        this.setState({
          serialNumber: (prefix != '_' ? prefix : '') + sequence
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.locale !== this.props.locale) {
      this.props.form.validateFields({ force: true });
    }
  }

  handleSubmit = event => {
    event.preventDefault();

    const { validateFields, getFieldValue, isFieldTouched } = this.props.form;
    // The force option is required because we have dynamic rules
    // See https://github.com/react-component/form/issues/130
    validateFields({ force: true }, (err, allValues) => {
      if (!err) {
        const signature = this.state.signature ? { signature: this.state.signature } : null;
        const logo = this.state.logo ? { logo: this.state.logo } : null;
        const updatedValues = pickBy(allValues, (value, key) => isFieldTouched(key));
        delete updatedValues['TaxReceiptAdminConfigurationInformationForm-acceptCheckbox'];
        if (this.props.configuration.prefix !== null && getFieldValue('prefix') === undefined) {
          updatedValues.prefix = null;
        }

        const values = {
          ...updatedValues,
          ...signature,
          ...logo
        };

        this.props.updateTaxReceiptConfigurationInformation(
          values,
          (this.props.configuration && this.props.configuration.statusId) || undefined
        );
        this.props.form.resetFields(['TaxReceiptAdminConfigurationInformationForm-acceptCheckbox']);
        this.hideActionModal();
      }
    });
  };

  handleCancel = event => {
    event.preventDefault();
    this.props.form.resetFields();
    this.updateSerialNumber(event);
    this.signatureUploadCropFieldRef.current.getWrappedInstance('UploadCropField').resetField();
    this.logoUploadCropFieldRef.current.getWrapperInstance('UploadCropField').resetField();
    this.setState({
      signature: null,
      logo: null
    });
  };

  formatSequence = sequence => {
    let number = sequence.toString();
    // Padding project has been cancelled.
    // while(number.length < 10) {
    //   number = "0" + number;
    // }
    return number;
  };

  updateSerialNumber = event => {
    let prefix, sequence, serialNumber;
    if (event.currentTarget.id === 'prefix') {
      prefix = event.currentTarget.value.toUpperCase() || '';
      this.props.form.setFieldsValue({ prefix: prefix });
    } else {
      prefix = this.props.form.getFieldValue('prefix') || '';
    }
    prefix = prefix + '_';
    if (event.currentTarget.id === 'sequence') {
      sequence = this.formatSequence(event.currentTarget.value);
    } else {
      sequence = this.formatSequence(this.props.form.getFieldValue('sequence'));
    }
    serialNumber = (prefix != '_' ? prefix : '') + sequence;
    if (this.state.serialNumber != serialNumber) {
      this.setState({
        serialNumber: serialNumber
      });
    }
  };

  showActionModal = () => {
    this.props.form.validateFields(
      ['prefix', 'sequence', 'signature'],
      { force: true },
      (err, allValues) => {
        if (!err) {
          if (this.props.configuration.sequence !== this.props.form.getFieldValue('sequence')) {
            if (this.props.configuration.prefix !== this.props.form.getFieldValue('prefix')) {
              this.setState({
                displayActionModal: true
              });
            }
          } else if (
            this.props.configuration.prefix !== this.props.form.getFieldValue('prefix') ||
            this.state.signature ||
            this.state.logo
          ) {
            this.setState({
              displayActionModal: true
            });
          }
        }
      }
    );
  };

  hideActionModal = () => {
    this.setState({
      displayActionModal: false,
      acceptModification: false
    });
  };

  handleCheckboxChange = event => {
    const value = event.target.checked;
    this.setState({
      acceptModification: value
    });
  };

  handleModalAccept = event => {
    this.handleSubmit(event);
  };

  handleModalCancel = event => {
    this.props.form.resetFields(['TaxReceiptAdminConfigurationInformationForm-acceptCheckbox']);
    this.hideActionModal();
  };

  // SIGNATURE
  handleSignatureCropComplete = image => {
    this.setState({
      signature: image
    });
    const img = this.props.form.getFieldsValue(['signature']);
    img.signature.data = image;
    this.props.form.setFieldsValue({ signature: img.signature });
  };

  handleDeleteSignature = () => {
    this.setState({
      signature: null,
      removeSignature: true
    });
  };
  // !SIGNATURE

  // LOGO
  handleLogoCropComplete = image => {
    this.setState({
      logo: image,
      removeLogo: false
    });
    const img = this.props.form.getFieldsValue(['logo']);
    img.logo.data = image;
    this.props.form.setFieldsValue({ logo: img.logo });
  };

  handleDeleteLogo = () => {
    this.setState({
      logo: null,
      removeLogo: true
    });
  };
  // !LOGO

  render() {
    const { props } = this,
      { t, configuration, form } = props,
      prefixRegex = /^[0-9A-Z]+$/g,
      numberRegex = /^[0-9]+$/g,
      amountRegex = /^[0-9.,]+$/g,
      disabled = false; //configuration && configuration.statusId === 1 ? true : false;

    const modificationModal = (
      <Modal
        className="TaxReceiptAdminConfigurationPanel--Modal"
        visible={this.state.displayActionModal ? true : false}
        footer={null}
        onCancel={this.handleModalCancel}
        maskClosable
      >
        <FundkyButton
          className="TaxReceiptAdminConfigurationPanel--closeModal"
          type="text"
          icon={['fas', 'times']}
          size="large"
          action={{ func: this.handleModalCancel }}
        />
        <h1>{t('modification')}</h1>
        <p>{t('modification-description')}</p>
        <CheckboxField
          form={this.props.form}
          fieldId="TaxReceiptAdminConfigurationInformationForm-acceptCheckbox"
          checkboxText={t('modification-checkbox')}
          onChange={this.handleCheckboxChange}
        />
        <div className="TaxReceiptAdminConfigurationPanel--buttons">
          <FundkyButton
            className=""
            type="cancel"
            text={t('cancel')}
            size="medium"
            action={{ func: this.handleModalCancel }}
          />
          <FundkyButton
            className=""
            type="primary"
            text={`${t('accept')}`}
            size="medium"
            loading={this.props.isUpdateConfigurationInProgress}
            action={{ func: this.handleModalAccept }}
            disabled={!this.state.acceptModification}
          />
        </div>
      </Modal>
    );

    return (
      <Form className="TaxReceiptAdminConfigurationInformationForm">
        <TextField
          form={form}
          label={t('prefix')}
          fieldId={'prefix'}
          initialValue={(this.props.configuration && this.props.configuration.prefix) || null}
          disabled={disabled}
          maxlength={9}
          counter={true}
          fieldOptions={{
            rules: [
              ...customFieldValidator(true, t('required-prefix'), prefixRegex, null, 0, 9, null)
            ]
          }}
          hasFeedback
          uppercase
          onInput={this.updateSerialNumber}
          onChange={() => {
            this.props.form.validateFields(['sequence'], { force: true });
          }}
          tooltip={t('prefix-tooltip')}
        />
        <TextField
          form={form}
          label={t('starting-number')}
          fieldId={'sequence'}
          initialValue={(this.props.configuration && this.props.configuration.sequence) || '1'}
          disabled={disabled}
          maxlength={10}
          counter={true}
          fieldOptions={{
            rules: [
              ...customFieldValidator(
                true,
                t('required-starting-number'),
                numberRegex,
                null,
                1,
                10,
                null
              ),
              {
                validator: (rule, value, callback) => {
                  let valid = false;

                  const prefixProps =
                    (this.props.configuration && this.props.configuration.prefix) || null;
                  const prefixField = this.props.form.getFieldValue('prefix');
                  const sequenceProps =
                    (this.props.configuration && this.props.configuration.sequence) || '1';
                  const sequenceField = this.props.form.getFieldValue('sequence');

                  if (
                    (!isNaN(parseInt(sequenceProps)) &&
                      !isNaN(parseInt(sequenceField)) &&
                      parseInt(sequenceProps) <= parseInt(sequenceField)) ||
                    (sequenceField && sequenceProps === sequenceField) ||
                    (sequenceField &&
                      sequenceProps !== sequenceField &&
                      prefixField &&
                      prefixProps !== prefixField)
                  ) {
                    valid = true;
                  }

                  return valid ? callback() : callback(true);
                },
                message: t('must-modify-prefix')
              }
            ]
          }}
          hasFeedback
          onInput={this.updateSerialNumber}
        />
        <FakeField className="" label={t('next-serial')} data={this.state.serialNumber} />
        <UploadCropField
          ref={this.signatureUploadCropFieldRef}
          form={form}
          fieldId="signature"
          initialValue={get(configuration, 'signature', null)}
          label={t('signature-label')}
          uploadTitle={t('signature-title')}
          aspectRatio={400 / 185}
          recommendedWidth={400}
          minWidth={400}
          required={true}
          requiredMessage={t('uploadSignature.UploadWall.required')}
          icon={['fal', 'signature']}
          handleCropConfirm={this.handleSignatureCropComplete}
          erasable={true}
          handleDelete={this.handleDeleteSignature}
        />
        <UploadCropField
          ref={this.logoUploadCropFieldRef}
          form={form}
          fieldId="logo"
          initialValue={get(configuration, 'logo', null)}
          label={t('Logo')}
          uploadTitle={t('Logo')}
          aspectRatio={365 / 160}
          recommendedWidth={365}
          minWidth={365}
          icon={['fal', 'image']}
          handleCropConfirm={this.handleLogoCropComplete}
          erasable={true}
          handleDelete={this.handleDeleteLogo}
          hasFeedback
          required
          requiredMessage={t('logo-required-message')}
        />
        {/* <TextField
          form={this.props.form}
          label={t('automatic-amount')}
          fieldId={'automaticSendAmount'}
          initialValue={null}
          fieldOptions={{
            rules: [
              ...customFieldValidator(false, amountRegex, null, null, null, null)
            ]
          }}
          onInput={this.updateSerialNumber}
          addonBefore={this.props.locale === 'en' ? '$' : null}
          addonAfter={this.props.locale === 'fr' ? `$ ${t('and more')}` : t('and-more')}
        /> */}
        <CancelAndSaveButtons
          onClickCancel={this.handleCancel}
          onClickSave={this.showActionModal}
          disabled={disabled}
          isSavingInProgress={this.props.isUpdateConfigurationInProgress}
        />
        {modificationModal}
      </Form>
    );
  }
}

export default translate('TaxReceiptAdminConfigurationInformationForm')(
  TaxReceiptAdminConfigurationInformationForm
);
